import { SUSPENSE_COMPETITOR, SUSPENSE_REASON } from '../../../../../../views/billing/subscription/constants';

export default {
  title: 'Facturation automatique',
  buttons: {
    add_subscription: 'Ajouter un abonnement',
    suspend_company: 'Suspendre le restaurant',
    restore_company: 'Restaurer le restaurant',
    edit_suspend: 'Modifier les infos de suspension',
    confirm: 'Confirmer',
    cancel: 'Annuler',
  },
  modals: {
    suspend_company: {
      title: 'Voulez-vous vraiment suspendre {{company}} ?',
      description:
        'Cela annulera tous les abonnements actifs, désactivera les commandes en direct et notifiera le propriétaire du restaurant par e-mail. Veuillez sélectionner une raison avant de confirmer.',
      suspense_reason: {
        label: 'Sélectionner la raison de suspension',
        placeholder: 'Choisir une raison',
        options: {
          [SUSPENSE_REASON.ClosedOrOwnershipChange]: 'Fermeture ou changement de propriétaire',
          [SUSPENSE_REASON.LowRoi]: 'Faible ROI',
          [SUSPENSE_REASON.PricingFeesSensitivity]: 'Sensibilité aux prix/frais',
          [SUSPENSE_REASON.MissingIntegrationsProductGaps]: 'Intégrations manquantes/lacunes produit',
          [SUSPENSE_REASON.PoorOnboardingActivation]: 'Mauvais onboarding/activation',
          [SUSPENSE_REASON.SupportDissatisfaction]: 'Insatisfaction du support',
          [SUSPENSE_REASON.SwitchedToCompetitor]: 'Passé à un concurrent/marketplace/DIY',
          [SUSPENSE_REASON.MarketingPerformanceDisappointment]: 'Déception des performances marketing',
          [SUSPENSE_REASON.WrongRegistrationData]: 'Enregistrement erroné / données incorrectes',
        },
        validation: {
          required: 'Veuillez choisir une raison',
        },
      },
      suspense_competitor: {
        label: 'Vers quel concurrent sont-ils passés ?',
        placeholder: 'Veuillez choisir un concurrent',
        options: {
          [SUSPENSE_COMPETITOR.Allo]: 'Allo',
          [SUSPENSE_COMPETITOR.Sides]: 'Slice',
          [SUSPENSE_COMPETITOR.Ordersmart]: 'Ordersmart',
          [SUSPENSE_COMPETITOR.RobinCook]: 'Robin Cook',
          [SUSPENSE_COMPETITOR.Lightspeed]: 'Lightspeed',
          [SUSPENSE_COMPETITOR.GastroMaster]: 'Gastro Master',
          [SUSPENSE_COMPETITOR.Dish]: 'Dish',
          [SUSPENSE_COMPETITOR.Other]: 'Autre',
        },
        validation: {
          required: 'Veuillez choisir un concurrent',
        },
      },
      suspense_reason_notes: {
        label: 'Contexte supplémentaire (facultatif)',
        placeholder: 'Fournissez des détails supplémentaires',
      },
    },
    restore_company: {
      title: 'Voulez-vous vraiment restaurer {{company}} ?',
      description: 'Vous devrez tout de même créer un abonnement et activer les commandes en direct manuellement.',
    },
  },
  toasts: {
    failed_to_load_data: "Échec du chargement des détails d'abonnement",
    failed_to_suspend_company: 'Échec de la suspension du restaurant. Veuillez contacter le support technique',
    failed_to_restore_company: 'Échec de la restauration du restaurant. Veuillez contacter le support technique',
  },
};
